import { render, staticRenderFns } from "./InternalOrders.vue?vue&type=template&id=54c97e80&scoped=true&"
import script from "./InternalOrders.vue?vue&type=script&lang=js&"
export * from "./InternalOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c97e80",
  null
  
)

export default component.exports